module.exports = __webpack_public_path__ + "static/media/type_b_id.457aca68.png";